import React, { useState } from "react";
import Logo from "../assets/images/logo.png";
import { Link, useLocation } from "react-router-dom";

function AppNav(props) {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [currentTab, setCurrentTab] = useState("active");
  return (
    <>
      <nav id="sidebar" className={props.sidebarClass}>
        <div className="sidebar-header admin_logo">
          {" "}
          <img src={Logo} />{" "}
        </div>
        <ul className="list-unstyled components sidebar ul.components li a svg path">
          <li className={splitLocation[1] === "adminDashBord" ? "active" : ""}>
            <Link to="/adminDashBord" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
              >
                <path
                  id="Path_83523"
                  data-name="Path 83523"
                  d="M56.75,395.5H65.5a1.181,1.181,0,0,1,1.25,1.25v8.75a1.181,1.181,0,0,1-1.25,1.25H56.75a1.181,1.181,0,0,1-1.25-1.25v-8.75A1.181,1.181,0,0,1,56.75,395.5ZM58,404.25h6.25V398H58Zm21.25-8.75H70.5a1.181,1.181,0,0,0-1.25,1.25v8.75a1.181,1.181,0,0,0,1.25,1.25h8.75a1.181,1.181,0,0,0,1.25-1.25v-8.75A1.181,1.181,0,0,0,79.25,395.5Zm-7.5,8.75H78V398H71.75Zm7.5,5H70.5a1.181,1.181,0,0,0-1.25,1.25v8.75a1.181,1.181,0,0,0,1.25,1.25h8.75a1.181,1.181,0,0,0,1.25-1.25V410.5A1.181,1.181,0,0,0,79.25,409.25ZM71.75,418H78v-6.25H71.75Zm-6.25-8.75H56.75a1.181,1.181,0,0,0-1.25,1.25v8.75a1.181,1.181,0,0,0,1.25,1.25H65.5a1.181,1.181,0,0,0,1.25-1.25V410.5A1.181,1.181,0,0,0,65.5,409.25ZM58,418h6.25v-6.25H58Z"
                  transform="translate(-55.5 -395.5)"
                  fill="#fff"
                  fill-rule="evenodd"
                />{" "}
              </svg>{" "}
              Admin Dashboard
            </Link>
          </li>
          <li className={splitLocation[1] === "evoOrders" ? "active" : ""}>
            <Link to="/evoOrders" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.864"
                height="25"
                viewBox="0 0 21.864 25"
              >
                <path
                  id="Path_83522"
                  data-name="Path 83522"
                  d="M77.871,346.08a.61.61,0,0,0,.121.17.649.649,0,0,1,.121.455v13.636a3.469,3.469,0,0,1-3.644,3.409H59.894a3.469,3.469,0,0,1-3.644-3.409V342.159a3.469,3.469,0,0,1,3.644-3.409h9.717a.77.77,0,0,1,.486.114c.121,0,.243.114.364.227l7.288,6.818A.593.593,0,0,1,77.871,346.08Zm-3.887-.512-3.158-2.955v2.955Zm.486,15.909H59.894a1.112,1.112,0,0,1-1.215-1.136V342.159a1.112,1.112,0,0,1,1.215-1.136h8.5V346.7a1.112,1.112,0,0,0,1.215,1.136h6.073v12.5A1.112,1.112,0,0,1,74.47,361.477Zm-2.429-7.955a1.139,1.139,0,1,0,0-2.273H62.323a1.139,1.139,0,1,0,0,2.273Zm1.215,3.409a1.112,1.112,0,0,1-1.215,1.136H62.323a1.139,1.139,0,1,1,0-2.273h9.717A1.112,1.112,0,0,1,73.256,356.932ZM62.323,346.7a1.139,1.139,0,1,0,0,2.273h2.429a1.139,1.139,0,1,0,0-2.273Z"
                  transform="translate(-56.25 -338.75)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
              Evo Orders{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "analystsCheckBox" ? "active" : ""}>
            <Link to="/analystsCheckBox" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22.5"
                height="25"
                viewBox="0 0 22.5 25"
              >
                <path
                  id="Path_83525"
                  data-name="Path 83525"
                  d="M60.25,590.75A6.25,6.25,0,1,1,66.5,597,6.189,6.189,0,0,1,60.25,590.75Zm17.5,15v2.5a1.25,1.25,0,0,1-2.5,0v-2.5A3.683,3.683,0,0,0,71.5,602h-10a3.683,3.683,0,0,0-3.75,3.75v2.5a1.25,1.25,0,0,1-2.5,0v-2.5a6.189,6.189,0,0,1,6.25-6.25h10A6.189,6.189,0,0,1,77.75,605.75ZM66.5,594.5a3.75,3.75,0,1,1,3.75-3.75A3.683,3.683,0,0,1,66.5,594.5Z"
                  transform="translate(-55.25 -584.5)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
              Analysts{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "applicants" ? "active" : ""}>
            <Link to="/applicants" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.893"
                height="22.578"
                viewBox="0 0 28.893 22.578"
              >
                <g
                  id="Group_40518"
                  data-name="Group 40518"
                  transform="translate(-53.444 -410.83)"
                  opacity="0.32"
                >
                  <path
                    id="Path_83863"
                    data-name="Path 83863"
                    d="M59.566,589.895a5.395,5.395,0,1,1,5.395,5.395A5.342,5.342,0,0,1,59.566,589.895Zm15.1,13.947V606a1.079,1.079,0,1,1-2.158,0v-2.158c0-1.834-1.4-4.237-3.237-4.237H60.645c-1.834,0-3.237,2.4-3.237,4.237V606a1.079,1.079,0,1,1-2.158,0v-2.158c0-3.021,2.374-6.395,5.395-6.395h8.631C72.3,597.447,74.67,600.82,74.67,603.841Zm-9.71-10.71a3.237,3.237,0,1,1,3.237-3.237A3.179,3.179,0,0,1,64.96,593.131Z"
                    transform="translate(-1.806 -173.67)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_83864"
                    data-name="Path 83864"
                    d="M59.047,589.246a4.746,4.746,0,1,1,4.746,4.746A4.7,4.7,0,0,1,59.047,589.246Zm13.29,11.392v1.9a.949.949,0,1,1-1.9,0v-1.9a2.8,2.8,0,0,0-2.848-2.848H61c-1.614,0-2.658-1.9,0-1.9h6.594A4.7,4.7,0,0,1,72.337,600.638Zm-8.544-8.544a2.848,2.848,0,1,1,2.848-2.848A2.8,2.8,0,0,1,63.794,592.094Z"
                    transform="translate(10 -171.078)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />{" "}
                </g>
              </svg>{" "}
              Analyst Applicants{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "teams" ? "active" : ""}>
            <Link to="/teams" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.893"
                height="22.578"
                viewBox="0 0 28.893 22.578"
              >
                <g
                  id="Group_40518"
                  data-name="Group 40518"
                  transform="translate(-53.444 -410.83)"
                  opacity="0.32"
                >
                  <path
                    id="Path_83863"
                    data-name="Path 83863"
                    d="M59.566,589.895a5.395,5.395,0,1,1,5.395,5.395A5.342,5.342,0,0,1,59.566,589.895Zm15.1,13.947V606a1.079,1.079,0,1,1-2.158,0v-2.158c0-1.834-1.4-4.237-3.237-4.237H60.645c-1.834,0-3.237,2.4-3.237,4.237V606a1.079,1.079,0,1,1-2.158,0v-2.158c0-3.021,2.374-6.395,5.395-6.395h8.631C72.3,597.447,74.67,600.82,74.67,603.841Zm-9.71-10.71a3.237,3.237,0,1,1,3.237-3.237A3.179,3.179,0,0,1,64.96,593.131Z"
                    transform="translate(-1.806 -173.67)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_83864"
                    data-name="Path 83864"
                    d="M59.047,589.246a4.746,4.746,0,1,1,4.746,4.746A4.7,4.7,0,0,1,59.047,589.246Zm13.29,11.392v1.9a.949.949,0,1,1-1.9,0v-1.9a2.8,2.8,0,0,0-2.848-2.848H61c-1.614,0-2.658-1.9,0-1.9h6.594A4.7,4.7,0,0,1,72.337,600.638Zm-8.544-8.544a2.848,2.848,0,1,1,2.848-2.848A2.8,2.8,0,0,1,63.794,592.094Z"
                    transform="translate(10 -171.078)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />{" "}
                </g>
              </svg>{" "}
              Teams{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "parents" ? "active" : ""}>
            <Link to="/parents" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22.5"
                height="25"
                viewBox="0 0 22.5 25"
              >
                <path
                  id="Path_83525"
                  data-name="Path 83525"
                  d="M60.25,590.75A6.25,6.25,0,1,1,66.5,597,6.189,6.189,0,0,1,60.25,590.75Zm17.5,15v2.5a1.25,1.25,0,0,1-2.5,0v-2.5A3.683,3.683,0,0,0,71.5,602h-10a3.683,3.683,0,0,0-3.75,3.75v2.5a1.25,1.25,0,0,1-2.5,0v-2.5a6.189,6.189,0,0,1,6.25-6.25h10A6.189,6.189,0,0,1,77.75,605.75ZM66.5,594.5a3.75,3.75,0,1,1,3.75-3.75A3.683,3.683,0,0,1,66.5,594.5Z"
                  transform="translate(-55.25 -584.5)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
              Parents{" "}
            </Link>
          </li>
          {/* <li className={splitLocation[1] === "rawVideo" ? "active" : ""}>
            <Link to="/rawVideo" style={{ textDecoration: "none" }}>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 459.58"
                width="28.893"
                height="22.578"
              >
                <path
                  d="M501.8,26.21H10.2A10.2,10.2,0,0,0,0,36.41V475.59a10.2,10.2,0,0,0,10.2,10.2H501.8a10.2,10.2,0,0,0,10.2-10.2V36.41A10.2,10.2,0,0,0,501.8,26.21ZM20.4,266.2H97.91V356H20.4Zm471.2-20.4h-49a10.2,10.2,0,0,0,0,20.4h49V356h-49a10.2,10.2,0,1,0,0,20.4h49v89H20.4v-89H97.91v66.3a10.2,10.2,0,0,0,10.2,10.19H403.89a10.2,10.2,0,0,0,10.2-10.19V156.05H491.6V245.8ZM118.31,432.45V79.55H393.69v352.9ZM491.6,135.65H414.09V69.36a10.2,10.2,0,0,0-10.2-10.2H108.11a10.2,10.2,0,0,0-10.2,10.2V245.8H20.4V156.05h52a10.2,10.2,0,0,0,0-20.4h-52v-89H491.6v89Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M330.33,247.75,206.92,158a10.19,10.19,0,0,0-16.19,8.25v179.5a10.19,10.19,0,0,0,5.57,9.09,10.08,10.08,0,0,0,4.62,1.11,10.19,10.19,0,0,0,6-1.95l123.41-89.75a10.2,10.2,0,0,0,0-16.5Zm-119.21,78V186.28L307,256Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M372.27,90.77a10.2,10.2,0,0,0-10.2,10.2v86.7a10.2,10.2,0,0,0,20.4,0V101A10.2,10.2,0,0,0,372.27,90.77Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M372.27,212.14a10.2,10.2,0,0,0-10.2,10.2V235.6a10.2,10.2,0,0,0,20.4,0V222.34A10.2,10.2,0,0,0,372.27,212.14Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
              </svg>
              Raw Video
            </Link>
          </li> */}
          <li className={splitLocation[1] === "rawVideo" ? "active" : ""}>
            <Link to="/sendvideolink" style={{ textDecoration: "none" }}>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 459.58"
                width="28.893"
                height="22.578"
              >
                <path
                  d="M501.8,26.21H10.2A10.2,10.2,0,0,0,0,36.41V475.59a10.2,10.2,0,0,0,10.2,10.2H501.8a10.2,10.2,0,0,0,10.2-10.2V36.41A10.2,10.2,0,0,0,501.8,26.21ZM20.4,266.2H97.91V356H20.4Zm471.2-20.4h-49a10.2,10.2,0,0,0,0,20.4h49V356h-49a10.2,10.2,0,1,0,0,20.4h49v89H20.4v-89H97.91v66.3a10.2,10.2,0,0,0,10.2,10.19H403.89a10.2,10.2,0,0,0,10.2-10.19V156.05H491.6V245.8ZM118.31,432.45V79.55H393.69v352.9ZM491.6,135.65H414.09V69.36a10.2,10.2,0,0,0-10.2-10.2H108.11a10.2,10.2,0,0,0-10.2,10.2V245.8H20.4V156.05h52a10.2,10.2,0,0,0,0-20.4h-52v-89H491.6v89Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M330.33,247.75,206.92,158a10.19,10.19,0,0,0-16.19,8.25v179.5a10.19,10.19,0,0,0,5.57,9.09,10.08,10.08,0,0,0,4.62,1.11,10.19,10.19,0,0,0,6-1.95l123.41-89.75a10.2,10.2,0,0,0,0-16.5Zm-119.21,78V186.28L307,256Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M372.27,90.77a10.2,10.2,0,0,0-10.2,10.2v86.7a10.2,10.2,0,0,0,20.4,0V101A10.2,10.2,0,0,0,372.27,90.77Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
                <path
                  d="M372.27,212.14a10.2,10.2,0,0,0-10.2,10.2V235.6a10.2,10.2,0,0,0,20.4,0V222.34A10.2,10.2,0,0,0,372.27,212.14Z"
                  transform="translate(0 -26.21)"
                  fill="#fff"
                />
              </svg>
              Send Video Link
            </Link>
          </li>
          {/* <li className={splitLocation[1] === "shareVideo" ? "active" : ""}>
            <Link to="/shareVideo" style={{ textDecoration: "none" }}>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 408.83 408.9"
                width="28.893"
                height="22.578"
              >
                <path
                  d="M47.26,423.56C40,422,33,419.75,27.08,414.8c-9.74-8.17-14.11-18.71-14.14-31.22,0-18.49,0-37,0-55.49q0-136.12,0-272.26c0-13.59,4.47-25,15.45-33.39a37.62,37.62,0,0,1,23.43-7.73q101.58-.09,203.16-.05A14,14,0,0,1,265.31,19c25.12,25.12,50.3,50.18,75.24,75.48a15.41,15.41,0,0,1,4.31,9.42c.43,16.62.2,33.26.19,49.89a6.5,6.5,0,0,1-.3,1.28H319.67V116.89H315q-22.15,0-44.3,0c-17.24,0-27.78-10.62-27.8-27.94q0-21.95,0-43.91V40.23H54c-10.83,0-15.48,4.68-15.48,15.59V382.37c0,10.92,4.65,15.63,15.44,15.63h86.76v25.56Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M421.73,325.33c-2.23,7.94-6,15-13.83,18.43a34.19,34.19,0,0,1-12.61,3c-16.47.34-33,.25-49.44.1-15.31-.13-26.18-10.89-26.27-26.16q-.24-37.68,0-75.38c.09-15.27,11-26,26.27-26.16,16.21-.15,32.43-.07,48.65,0,13.79,0,22.66,6.81,26.57,20.12a11.51,11.51,0,0,0,.66,1.43v4H345.39v76.66h50.54V295.61H370.84V270.55c9.74,0,19.28-.19,28.8.13,2.79.09,5.68,1.36,8.27,2.6,7.79,3.72,11.59,10.56,13.82,18.51Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M307.07,283c-.36,10.09.25,20.19-3.33,30-8,21.81-29.59,35.83-52.39,33.73-23.86-2.19-43.17-19.9-46-43.65-1.77-15-2.5-30.35.87-45.26,5.38-23.75,27.65-39.82,52.3-38.6A50.63,50.63,0,0,1,306,262.72C306.9,269.41,306.74,276.24,307.07,283Zm-25.88.1c0-4.25.11-8.51,0-12.76-.43-14.61-11.56-25.72-25.6-25.65s-25,11-25.4,25.43c-.24,8.63-.26,17.29,0,25.92.45,14.38,11.67,25.32,25.56,25.25s24.93-11,25.43-25.42C281.31,291.63,281.19,287.37,281.19,283.11Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M115.13,219.11h25.46V321.17h50.86v25.54c-1.14.06-2.41.17-3.69.17q-28.92,0-57.85,0c-9.8,0-14.77-4.93-14.77-14.67q0-54.68,0-109.34Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
              </svg>
              Logs - Share Video
            </Link>
          </li> */}

          {/* <li className={splitLocation[1] === "viewLogs" ? "active" : ""}>
            <Link to="/viewLogs" style={{ textDecoration: "none" }}>
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 408.83 408.9"
                width="28.893"
                height="22.578"
              >
                <path
                  d="M47.26,423.56C40,422,33,419.75,27.08,414.8c-9.74-8.17-14.11-18.71-14.14-31.22,0-18.49,0-37,0-55.49q0-136.12,0-272.26c0-13.59,4.47-25,15.45-33.39a37.62,37.62,0,0,1,23.43-7.73q101.58-.09,203.16-.05A14,14,0,0,1,265.31,19c25.12,25.12,50.3,50.18,75.24,75.48a15.41,15.41,0,0,1,4.31,9.42c.43,16.62.2,33.26.19,49.89a6.5,6.5,0,0,1-.3,1.28H319.67V116.89H315q-22.15,0-44.3,0c-17.24,0-27.78-10.62-27.8-27.94q0-21.95,0-43.91V40.23H54c-10.83,0-15.48,4.68-15.48,15.59V382.37c0,10.92,4.65,15.63,15.44,15.63h86.76v25.56Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M421.73,325.33c-2.23,7.94-6,15-13.83,18.43a34.19,34.19,0,0,1-12.61,3c-16.47.34-33,.25-49.44.1-15.31-.13-26.18-10.89-26.27-26.16q-.24-37.68,0-75.38c.09-15.27,11-26,26.27-26.16,16.21-.15,32.43-.07,48.65,0,13.79,0,22.66,6.81,26.57,20.12a11.51,11.51,0,0,0,.66,1.43v4H345.39v76.66h50.54V295.61H370.84V270.55c9.74,0,19.28-.19,28.8.13,2.79.09,5.68,1.36,8.27,2.6,7.79,3.72,11.59,10.56,13.82,18.51Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M307.07,283c-.36,10.09.25,20.19-3.33,30-8,21.81-29.59,35.83-52.39,33.73-23.86-2.19-43.17-19.9-46-43.65-1.77-15-2.5-30.35.87-45.26,5.38-23.75,27.65-39.82,52.3-38.6A50.63,50.63,0,0,1,306,262.72C306.9,269.41,306.74,276.24,307.07,283Zm-25.88.1c0-4.25.11-8.51,0-12.76-.43-14.61-11.56-25.72-25.6-25.65s-25,11-25.4,25.43c-.24,8.63-.26,17.29,0,25.92.45,14.38,11.67,25.32,25.56,25.25s24.93-11,25.43-25.42C281.31,291.63,281.19,287.37,281.19,283.11Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
                <path
                  d="M115.13,219.11h25.46V321.17h50.86v25.54c-1.14.06-2.41.17-3.69.17q-28.92,0-57.85,0c-9.8,0-14.77-4.93-14.77-14.67q0-54.68,0-109.34Z"
                  transform="translate(-12.9 -14.66)"
                  fill="#fff"
                />
              </svg>
              Logs - View Video
            </Link>
          </li> */}
          <li className={splitLocation[1] === "adsListing" ? "active" : ""}>
            <Link to="/adsListing" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26.728"
                height="22.722"
                viewBox="0 0 26.728 22.722"
              >
                <path
                  id="Path_83969"
                  data-name="Path 83969"
                  d="M25.2,3H3.525A2.532,2.532,0,0,0,1,5.525V23.2a2.532,2.532,0,0,0,2.525,2.525H25.2A2.532,2.532,0,0,0,27.728,23.2V5.525A2.532,2.532,0,0,0,25.2,3Zm0,20.2H3.525V5.525H25.2ZM5.93,7.93H16.148v7.694H5.93Z"
                  transform="translate(-1 -3)"
                  fill="#fff"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
              Ads Listing
            </Link>
          </li>
          <li className={splitLocation[1] === "swimfaqs" ? "active" : ""}>
            <Link to="/swimfaqs" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.864"
                height="25"
                viewBox="0 0 21.864 25"
              >
                <path
                  id="Path_83522"
                  data-name="Path 83522"
                  d="M77.871,346.08a.61.61,0,0,0,.121.17.649.649,0,0,1,.121.455v13.636a3.469,3.469,0,0,1-3.644,3.409H59.894a3.469,3.469,0,0,1-3.644-3.409V342.159a3.469,3.469,0,0,1,3.644-3.409h9.717a.77.77,0,0,1,.486.114c.121,0,.243.114.364.227l7.288,6.818A.593.593,0,0,1,77.871,346.08Zm-3.887-.512-3.158-2.955v2.955Zm.486,15.909H59.894a1.112,1.112,0,0,1-1.215-1.136V342.159a1.112,1.112,0,0,1,1.215-1.136h8.5V346.7a1.112,1.112,0,0,0,1.215,1.136h6.073v12.5A1.112,1.112,0,0,1,74.47,361.477Zm-2.429-7.955a1.139,1.139,0,1,0,0-2.273H62.323a1.139,1.139,0,1,0,0,2.273Zm1.215,3.409a1.112,1.112,0,0,1-1.215,1.136H62.323a1.139,1.139,0,1,1,0-2.273h9.717A1.112,1.112,0,0,1,73.256,356.932ZM62.323,346.7a1.139,1.139,0,1,0,0,2.273h2.429a1.139,1.139,0,1,0,0-2.273Z"
                  transform="translate(-56.25 -338.75)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
              FAQs{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "payment-history" ? "active" : ""}>
            <Link to="/payment-history" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.893"
                height="22.578"
                viewBox="0 0 28.893 22.578"
              >
                <g
                  id="Group_40519"
                  data-name="Group 40519"
                  transform="translate(-53.444 -410.83)"
                  opacity="0.32"
                >
                  <path
                    id="Path_83865"
                    data-name="Path 83865"
                    d="M53.444,410.83H82.337a3.018,3.018,0,0,1,3.018,3.018v14.148a3.018,3.018,0,0,1-3.018,3.018H53.444a3.018,3.018,0,0,1-3.018-3.018V413.847A3.018,3.018,0,0,1,53.444,410.83ZM67.02,423.269a2.846,2.846,0,1,1,2.846-2.846A2.847,2.847,0,0,1,67.02,423.269Zm-6.709-2.8H55.88a.951.951,0,1,0,0,1.9h4.163a.951.951,0,1,0,0-1.9Zm17.39,0H70.23a.951.951,0,1,0,0,1.9h4.163a.951.951,0,1,0,0-1.9Zm-7.39-5.492a4.741,4.741,0,1,1,4.741-4.741A4.748,4.748,0,0,1,70.7,414.977Zm-2.009,7.448a.951.951,0,1,0-1.9,0v1.9a.951.951,0,1,0,1.9,0v-1.9Zm11.989,0a.951.951,0,1,0-1.9,0v1.9a.951.951,0,1,0,1.9,0v-1.9Z"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                </g>
              </svg>
              Payment History{" "}
            </Link>
          </li>
          <li className={splitLocation[1] === "evo-package" ? "active" : ""}>
            <Link to="/evo-package" style={{ textDecoration: "none" }}>
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.864"
                height="25"
                viewBox="0 0 21.864 25"
              >
                <path
                  id="Path_83522"
                  data-name="Path 83522"
                  d="M77.871,346.08a.61.61,0,0,0,.121.17.649.649,0,0,1,.121.455v13.636a3.469,3.469,0,0,1-3.644,3.409H59.894a3.469,3.469,0,0,1-3.644-3.409V342.159a3.469,3.469,0,0,1,3.644-3.409h9.717a.77.77,0,0,1,.486.114c.121,0,.243.114.364.227l7.288,6.818A.593.593,0,0,1,77.871,346.08Zm-3.887-.512-3.158-2.955v2.955Zm.486,15.909H59.894a1.112,1.112,0,0,1-1.215-1.136V342.159a1.112,1.112,0,0,1,1.215-1.136h8.5V346.7a1.112,1.112,0,0,0,1.215,1.136h6.073v12.5A1.112,1.112,0,0,1,74.47,361.477Zm-2.429-7.955a1.139,1.139,0,1,0,0-2.273H62.323a1.139,1.139,0,1,0,0,2.273Zm1.215,3.409a1.112,1.112,0,0,1-1.215,1.136H62.323a1.139,1.139,0,1,1,0-2.273h9.717A1.112,1.112,0,0,1,73.256,356.932ZM62.323,346.7a1.139,1.139,0,1,0,0,2.273h2.429a1.139,1.139,0,1,0,0-2.273Z"
                  transform="translate(-56.25 -338.75)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
               Evo Package
            </Link>
          </li>
          <li className={splitLocation[1] === "coupon-code" ? "active" : ""}>
            <Link to="/coupon-code" style={{ textDecoration: "none" }}>
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.864"
                height="25"
                viewBox="0 0 21.864 25"
              >
                <path
                  id="Path_83522"
                  data-name="Path 83522"
                  d="M77.871,346.08a.61.61,0,0,0,.121.17.649.649,0,0,1,.121.455v13.636a3.469,3.469,0,0,1-3.644,3.409H59.894a3.469,3.469,0,0,1-3.644-3.409V342.159a3.469,3.469,0,0,1,3.644-3.409h9.717a.77.77,0,0,1,.486.114c.121,0,.243.114.364.227l7.288,6.818A.593.593,0,0,1,77.871,346.08Zm-3.887-.512-3.158-2.955v2.955Zm.486,15.909H59.894a1.112,1.112,0,0,1-1.215-1.136V342.159a1.112,1.112,0,0,1,1.215-1.136h8.5V346.7a1.112,1.112,0,0,0,1.215,1.136h6.073v12.5A1.112,1.112,0,0,1,74.47,361.477Zm-2.429-7.955a1.139,1.139,0,1,0,0-2.273H62.323a1.139,1.139,0,1,0,0,2.273Zm1.215,3.409a1.112,1.112,0,0,1-1.215,1.136H62.323a1.139,1.139,0,1,1,0-2.273h9.717A1.112,1.112,0,0,1,73.256,356.932ZM62.323,346.7a1.139,1.139,0,1,0,0,2.273h2.429a1.139,1.139,0,1,0,0-2.273Z"
                  transform="translate(-56.25 -338.75)"
                  fill="#fff"
                  fill-rule="evenodd"
                  opacity="0.32"
                />{" "}
              </svg>{" "}
               Coupon Generator
            </Link>
          </li>
          <li className={splitLocation[1] === "master-key" ? "active" : ""}>
            <Link to="/master-key" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 0C9.243 0 7 2.243 7 5v4H4c-1.104 0-2 .896-2 2v10c0 1.104.896 2 2 2h16c1.104 0 2-.896 2-2V11c0-1.104-.896-2-2-2h-3V5c0-2.757-2.243-5-5-5zm0 2c1.654 0 3 1.346 3 3v4H9V5c0-1.654 1.346-3 3-3zm-1 9h2v2h-2v-2zm0 4h2v2h-2v-2z"
                  fill="#000"
                />
              </svg>
               Master Key
            </Link>
          </li>
          <li className={splitLocation[1] === "restore-tablet-permission" ? "active" : ""}>
            <Link to="/restore-tablet-permission" style={{ textDecoration: "none" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 0c-2.21 0-4 1.79-4 4v4H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2h-2V4c0-2.21-1.79-4-4-4zm0 2c1.1 0 2 .9 2 2v4h-4V4c0-1.1.9-2 2-2zm-1 9h2v2h-2zm0 4h2v2h-2z"
                  fill="#000"
                />
              </svg>
              Restore Tablet Permission
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default AppNav;
